import conf from '../../shared/conf.js';

const stepsNumber = 4;

/**
 * Donne le pourcentage de step terminée
 * @param {Object} user
 * @returns {number}
 */
export function getPercent(user) {
  return Math.round((getLastStepDone(user) * 100) / stepsNumber);
}

/**
 * Récupère la dernière step qui a été validée
 * @param {Object} user
 * @param {Object} freelance
 * @returns number
 */
export function getLastStepDone(user, freelance = null) {

  if(freelance && freelance.current_registration_step && !isNaN(Number(freelance.current_registration_step))){
    return Number(freelance.current_registration_step)
  }

  let lastStep = 0;

  if (user.account_type !== conf.accountTypes.freelance || !freelance || user.freelance_id !== freelance.id) {
    return lastStep;
  }

  if (!user.firstname || !user.lastname || !user.tel) {
    return lastStep;
  }
  lastStep += 1;

  if (!user.meeting && !user.hasMeetingScheduled) {
    return lastStep;
  }
  lastStep += 1;

  if (!freelance.situation || !freelance.date_available || (!freelance.price && !freelance.yearly_brut)) {
    return lastStep;
  }

  return lastStep;
}
